/** One outlined asset keeps the website and downloaded wordmark identical. */
export default function Wordmark({ className = '' }: { className?: string }) {
  return <img className={`seek-wordmark ${className}`.trim()} src="/brand/cityseek-wordmark.svg" width="3985" height="967" alt="" aria-hidden="true" />;
}
